import { AvailablePrinter } from '@/modules/printModule/services/anapath-printer-rest-client/anapath-printer-rest-client.model'
import {
    ReportModelConfigurationMatch,
    UserappReportModelConfigurationResponse
} from '@/modules/printModule/services/report-model-configuration/report-model-configuration.model'
import { store } from '@/store/store'

export interface UserConfigurationPrintTabState {
    status: boolean
    workstation: string
    printers: AvailablePrinter[]
    devices: UserappReportModelConfigurationResponse[]
    reportModels: ReportModelConfigurationMatch[]
    laboratoryId: number
}
export const initialUserConfigurationPrintTabState =
    (): UserConfigurationPrintTabState => ({
        status: false,
        workstation: '',
        printers: [],
        devices: [],
        reportModels: [],
        laboratoryId: store.getters.labId
    })
